export function getPublishPathLabel(siteUrl: string | undefined, fallbackLabel: string): string {
  if (siteUrl) {
    try {
      const host = new URL(siteUrl).hostname.replace(/^www\./, '');
      return `${host}/category/all-products`;
    } catch {
      // fall through
    }
  }
  return fallbackLabel;
}
